import { BaseEntity } from '@/actions/dtos/baseEntity';

export interface Subscription {
  tier: SubscriptionTier;
  usage: CapabilityUsage;
  limits: CapabilityLimits;
  capabilities: CapabilityFlags;
}

export enum SubscriptionTier {
  BASIC = 'BASIC',
  PROFESSIONAL = 'PROFESSIONAL',
  ULTIMATE = 'ULTIMATE',
  ENTERPRISE = 'ENTERPRISE',
}

export enum PaymentMethod {
  SEND_INVOICE = 'SEND_INVOICE',
}

type CapabilityUsage = {
  [key in Capability]: number;
};

type CapabilityLimits = {
  [key in Capability]: number;
};

type CapabilityFlags = {
  [key in Capability]?: boolean;
};

export enum Capability {
  ACCOUNTS = 'ACCOUNTS',
  QUERIES = 'QUERIES',
  SHORTLISTS = 'SHORTLISTS',
  AGENTS = 'AGENTS',
  QUESTIONS = 'QUESTIONS',
  RESULTS = 'RESULTS',
  TENDER_ACCESS = 'TENDER_ACCESS',
  WEBHOOKS = 'WEBHOOKS',
}

export interface Trial extends BaseEntity {
  validFrom: string;
  validTo: string;
  subscriptionTier: SubscriptionTier;
  duration: string;
  activation?: string;
  deactivation?: string;
}

export interface Customer extends BaseEntity {
  existingStripeAccount: boolean;
  existingStripeSubscription: boolean;
  currentSubscription: Subscription;
  currentTrial?: Trial;
}
